// extracted by mini-css-extract-plugin
export default {"canvasFooter":"FenceCanvasFooter_canvasFooter__K4Rdm"};